import { useMemo } from 'react';
import { getCurrencySymbol } from '@restworld/utils-common';

import { CardWrapper, CardJpDetails, CardVenueDetails, WorkerBaseCardVariant } from './worker-base-card';

export function WorkerJpCard({
  restaurantLogo,
  restaurantName,
  publishedAt,
  city,
  redirectUrl,
  newTab,
  occupation,
  salaryMin,
  salaryMax,
  salary,
  salaryCurrency,
  jobType,
  jobTitle,
  onClick,
  wrapperStyle,
  isJobPositionOutsideItaly,
  hasAlreadyApplied,
}: WorkerJpCardProps) {
  const variant: WorkerBaseCardVariant = 'jp';

  const currencySymbol = useMemo(() => getCurrencySymbol(salaryCurrency), [salaryCurrency]);

  const badges = useMemo(
    () =>
      [
        occupation || '',
        salaryMax && salaryMax
          ? `${currencySymbol}${salaryMin}-${salaryMax}`
          : salary
          ? `${currencySymbol}${salary}`
          : '',
        jobType || '',
      ].filter(Boolean),
    [currencySymbol, jobType, occupation, salary, salaryMax, salaryMin]
  );

  return (
    <CardWrapper variant={variant} href={redirectUrl} newTab={newTab} onClick={onClick} wrapperStyle={wrapperStyle}>
      <CardJpDetails badges={badges} title={jobTitle} />
      <CardVenueDetails
        variant={variant}
        logoSrc={restaurantLogo}
        city={city}
        firstSubDate={publishedAt}
        venueName={restaurantName}
        isOutsideItaly={isJobPositionOutsideItaly}
        hasAlreadyApplied={hasAlreadyApplied}
      />
    </CardWrapper>
  );
}

export interface WorkerJpCardProps {
  restaurantLogo: string;
  restaurantName?: string;
  publishedAt?: string;
  city?: string;
  redirectUrl?: string;
  newTab?: boolean;
  jobTitle?: string;
  occupation: string;
  salaryMin: string | number;
  salaryMax: string | number;
  salary?: string | number;
  salaryCurrency?: string;
  jobType: string;
  onClick?: () => void;
  wrapperStyle?: string;
  isJobPositionOutsideItaly?: boolean;
  hasAlreadyApplied?: boolean;
}
